import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "selected"];
import React, { useContext } from 'react';
import { intrinsicComponent } from '../../utils/functions';
import DrawerContext from './drawer.context';
import Styled from './drawer.styles';
var DrawerItem = intrinsicComponent(function (_ref, ref) {
  var children = _ref.children,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(DrawerContext),
    isCollapsed = _useContext.isCollapsed;
  return /*#__PURE__*/React.createElement(Styled.Item, _extends({
    selected: selected,
    isCollapsed: isCollapsed
  }, rest, {
    ref: ref
  }), children);
});
export default DrawerItem;